import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { DocumentoAccredito, Evento } from '../../../../shared/interface';
import { Table } from 'primeng/table';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-documenti-accrediti-backoffice',
  templateUrl: './documenti-accrediti-backoffice.component.html',
  styleUrls: ['./documenti-accrediti-backoffice.component.css']
})
export class DocumentiAccreditiBackofficeComponent {

  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService
  ) {}

  @ViewChild('delete') delete!: ConfirmPopup;

  @Input() documenti: DocumentoAccredito[] = [];  
  @Input() evento?: Evento;

  documento?: DocumentoAccredito;

  loading: boolean = false;    

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.documenti = changes['documenti']?.currentValue || this.documenti;    
    this.evento = changes['evento']?.currentValue || this.evento;    
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDelete(event: Event, documento: DocumentoAccredito, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler rimuovere il documento?`,
      reject: () => this.confirmationService.close(),
      accept: () => {        
        this.apiService.deleteDocumentoAccredito(documento.id).subscribe({
          next: (data) => this.apiService.setDocumentiEvento(this.evento!.id),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.message("success", "Eliminazione", "Il documento è stato eliminato con successo!")
          }
        })
      },
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onClose() {
    this.delete.reject();
  }

  onZip() {
    this.loading = true;
    // Recupero la ricevuta
    this.apiService.getZipDocumenti(this.documenti).subscribe({
      next: (data) => {
        const url = window.URL.createObjectURL(data);
        const a = document.createElement('a');
        a.target = '_blank'
        a.href = url;
        a.download = `documenti.zip`;
        a.click();
        this.loading = false;
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);       
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
    });
  }

  onStato(stato: string, documento: DocumentoAccredito) {
    this.loading = true;
    this.apiService.updateStatoDocumento(stato, documento.id).subscribe({
      next: (data) => documento.stato = stato,
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err.message)        
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  scadenzaValue(documento: DocumentoAccredito): string {
    if (!documento.data_scadenza) return '';
    const d = new Date(documento.data_scadenza);
    if (Number.isNaN(d.getTime())) return '';
    return d.toISOString().slice(0, 10);
  }

  isScaduto(documento: DocumentoAccredito): boolean {
    if (!documento.data_scadenza) return false;
    const d = new Date(documento.data_scadenza);
    if (Number.isNaN(d.getTime())) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    return d.getTime() < today.getTime();
  }

  onScadenza(event: Event, documento: DocumentoAccredito) {
    const value = (event.target as HTMLInputElement).value || null;
    this.loading = true;
    this.apiService.updateScadenzaDocumento(value, documento.id).subscribe({
      next: () => {
        documento.data_scadenza = value;
        this.apiService.message('success', 'Scadenza', value ? 'Data aggiornata' : 'Scadenza rimossa');
      },
      error: (err) => {
        this.loading = false;
        this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message);
      },
      complete: () => { this.loading = false; },
    });
  }
}
